import styled from "styled-components";

export const SpinnerSubtextDefaultBox = styled.div`
  font-size: 2rem;
  position: relative;
  top: 200px;
  text-align: center;
`;